
<template>
    <div class="text-caption">
        <q-card flat bordered>
            <q-card-section>
                <div>PERSONAL INFORMATION</div>
            </q-card-section>
            <q-separator/>
            <q-card-section>
                <div class="row q-pb-sm">
                    <div class=" col-6">
                        Salutation 
                    </div>
                    <div class="col-6">
                        : {{StoreStateAOD.PersonalInformation.Salutation}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        Full Name as in IC / Passport 
                    </div>
                    <div class="col-6">
                        : {{StoreStateAOD.PersonalInformation.FullName}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        NRIC :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.NRIC}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        Old ID :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.OldID}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        Race :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.Race}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        Date of Birth :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.DateOfBirth}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        Gender :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.Gender}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        Nationality :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.Nationality}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        EPF No :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.EPFNumber}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-6">
                        Holder Status :
                    </div>
                    <div class="col-6">
                         {{StoreStateAOD.PersonalInformation.HolderStatus}}
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryPersonalInformationMobile',
    data() {
        return {
            StoreStateAOD : store.state.AOD
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>